// Trail hazards: the wire vocabulary the web shares with the apps and the
// Martin tiles (see db/functions/get_trail_hazards_v2.sql). Lower-case values,
// exactly as the tiles' `hazard_type` / `confirmation_state` / `passability`
// properties carry them; GraphQL sends the same values upper-cased.

/** The hazard types, in the order the apps show them as chips (`fire` came later, last). */
export const HAZARD_TYPES = [
  'flooded_path',
  'tree_down',
  'path_closed',
  'livestock_wildlife',
  'path_hard_to_follow',
  'boggy_ground',
  'heavy_vegetation',
  'rockfall_landslip',
  'ice_snow',
  'bridge_damage',
  'fire',
] as const;

export type HazardType = typeof HAZARD_TYPES[number];

export const CONFIRMATION_STATES = ['unconfirmed', 'confirmed'] as const;
export type ConfirmationState = typeof CONFIRMATION_STATES[number];

export const PASSABILITIES = ['passable', 'blocked'] as const;
export type Passability = typeof PASSABILITIES[number];

/** `FLOODED_PATH` (GraphQL) or `flooded_path` (tiles) → `flooded_path`; null for anything else. */
function fromWire<T extends string>(allowed: readonly T[], value: unknown): T | null {
  if (typeof value !== 'string') return null;
  const lower = value.trim().toLowerCase();
  return (allowed as readonly string[]).includes(lower) ? (lower as T) : null;
}

export const hazardTypeFromWire = (value: unknown): HazardType | null => fromWire(HAZARD_TYPES, value);
export const confirmationStateFromWire = (value: unknown): ConfirmationState | null => fromWire(CONFIRMATION_STATES, value);
export const passabilityFromWire = (value: unknown): Passability | null => fromWire(PASSABILITIES, value);
